// Web entrypoint for the Miri embed. Same RN-Web bootstrap as the
// fridays/ demo (which proved the bundler shape works), trimmed of the
// partner-specific flourishes. Lives at embed.miri.ai/* and serves
// per-surface routes (e.g. /chat) for partners to iframe.

import { AppRegistry } from 'react-native';

// react-native-vector-icons fonts (some SDK surfaces use FontAwesome5
// glyphs in chips / list rows). Same @font-face setup as fridays/.
import faSolid from 'react-native-vector-icons/Fonts/FontAwesome5_Solid.ttf?url';
import faRegular from 'react-native-vector-icons/Fonts/FontAwesome5_Regular.ttf?url';

const fontFaceCss = `
@font-face { font-family: 'FontAwesome5_Solid'; src: url(${faSolid}) format('truetype'); }
@font-face { font-family: 'FontAwesome5_Regular'; src: url(${faRegular}) format('truetype'); }
@font-face { font-family: 'FontAwesome5Free-Solid'; src: url(${faSolid}) format('truetype'); }
@font-face { font-family: 'FontAwesome5Free-Regular'; src: url(${faRegular}) format('truetype'); }
`;
const styleEl = document.createElement('style');
styleEl.appendChild(document.createTextNode(fontFaceCss));
document.head.appendChild(styleEl);

// Runtime require() dispatcher for the small set of SDK / RN-web calls
// that bypass Vite's resolve.alias (they happen via dynamic `require()`).
import createReactDOMStyle from 'react-native-web/dist/exports/StyleSheet/compiler/createReactDOMStyle';
import preprocessStyle from 'react-native-web/dist/exports/StyleSheet/preprocess';
import LottieView from 'lottie-react-native';
import LinearGradient from 'react-native-linear-gradient';
import BlurView from '@react-native-community/blur';
import * as expoCamera from 'expo-camera';

const lottieModule = { default: LottieView, LottieView };
const linearGradientModule = { default: LinearGradient, LinearGradient };
const blurModule = { default: BlurView, BlurView };

const KNOWN_REQUIRES: Record<string, unknown> = {
  'react-native-web/dist/exports/StyleSheet/compiler/createReactDOMStyle': createReactDOMStyle,
  'react-native-web/dist/exports/StyleSheet/preprocess': preprocessStyle,
  'lottie-react-native': lottieModule,
  'lottie-react': lottieModule,
  'react-native-linear-gradient': linearGradientModule,
  'expo-linear-gradient': linearGradientModule,
  'expo-blur': blurModule,
  '@react-native-community/blur': blurModule,
  'expo-camera': expoCamera,
};

const originalRequire = (window as unknown as { require?: (id: string) => unknown }).require;
(window as unknown as { require: (id: string) => unknown }).require = (id: string) => {
  if (KNOWN_REQUIRES[id] !== undefined) return KNOWN_REQUIRES[id];
  return originalRequire ? originalRequire(id) : null;
};

import { App } from './App';

AppRegistry.registerComponent('MiriEmbed', () => App);
AppRegistry.runApplication('MiriEmbed', {
  rootTag: document.getElementById('root'),
});
